export const ANALYTICS_EVENT_TYPES = Object.freeze({
  ADMIN_CONTENT_LEGACY_ROUTE_USED: 'ADMIN_CONTENT_LEGACY_ROUTE_USED'
})
